import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { useSelector } from 'react-redux';
import { getUsername, getOrg, isUserAdmin, isUserSignedIn } from '../../reducers/currentUser';

const useStyles = () => ({
  icon: {
    padding: 4,
    color: 'rgb(34, 70, 127)',
    width: 36,
    height: 36,
  },
  text: {
    color: 'rgb(34, 70, 127)',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'rgb(34, 70, 127)',
  },

});

const AccountDetails = () => {
  const styles = useStyles();
  const userName = useSelector(getUsername);
  const isAuthed = useSelector(isUserSignedIn);
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin/dashboard' || location.pathname === '/admin/users' || location.pathname === '/admin/invite';
  const user = userName.split(' ')[0];
  const firstLetter = user.charAt(0).toUpperCase();
  const isAdmin = useSelector(isUserAdmin);
  const org = useSelector(getOrg);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Tooltip title="Open settings">
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          style={styles.button}
        >
          <AccountCircleIcon style={styles.icon} />
          <Typography variant="body2" style={styles.text}>{user}</Typography>
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="user-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Stack alignItems="center">
          <Avatar>{firstLetter}</Avatar>
          <Typography variant="body2">{userName}</Typography>
          <Typography variant="body2">{org}</Typography>
        </Stack>
        <Divider />
        <Stack>
          <MenuItem
            dense
            component="a"
            href="/change"
            sx={{ textDecoration: 'none', color: 'inherit' }}
          >
            Change password
          </MenuItem>
          {(isAdmin && !isAdminRoute) && (
            <MenuItem
              dense
              component={Link}
              to="/admin"
            >
              Manage users
            </MenuItem>
          )}
          {(isAdminRoute && isAuthed) && (
            <MenuItem
              dense
              component={Link}
              to="/"
            >
              Back to main page
            </MenuItem>
          )}
          <MenuItem
            dense
            component="a"
            href="/logout"
            rel="noopener"
            sx={{ textDecoration: 'none', color: 'inherit' }}
          >
            Logout
          </MenuItem>
        </Stack>
      </Menu>
    </div>
  );
};
export default AccountDetails;
